import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    padding: "10px 15px",
    minWidth: 120,
    fontSize: 16,
  },
  chip: {
    margin: 2,
  },
});
